module.exports = __webpack_public_path__ + "app/principal/principal-acquittal-18ld4Mih.html";